import FoulingData from "./data";
import mapFoulingPolynomialsData from "./polynomials/mapper";
import mapMeanChangeAdjData from "./mean_change_adj/mapper";
import mapFoulingConfigData from "./fouling_config/mapper";
import mapFoulingLogData from "./log/mapper";

export default function mapFoulingData(json) {
    return new FoulingData(
        json.polynomials ? json.polynomials.map(mapFoulingPolynomialsData) : null,
        json.mean_change_adj ? json.mean_change_adj.map(mapMeanChangeAdjData) : null,
        json.foulingConfig ? mapFoulingConfigData(json.foulingConfig) : null,
        json.log ? json.log.map(mapFoulingLogData) : null
    );
} 
